import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="section-title">吃瓜热榜</h2>
          <p className="section-subtitle">实时热度排行，今天最火的瓜都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-3 md:gap-4 py-3 md:py-4 border-b border-background-200 last:border-b-0 group cursor-pointer hover:bg-background-100/50 px-3 md:px-4 rounded-lg transition-colors -mx-3 md:-mx-4"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm md:text-base ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-primary-400 text-white'
                  : item.rank === 3
                  ? 'bg-accent-500 text-white'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                {item.trend === 'up' && (
                  <i className="ri-arrow-up-line text-primary-500 text-sm"></i>
                )}
                {item.trend === 'down' && (
                  <i className="ri-arrow-down-line text-secondary-500 text-sm"></i>
                )}
                {item.trend === 'new' && (
                  <span className="text-xs font-medium text-accent-500 bg-accent-50 px-1.5 py-0.5 rounded">NEW</span>
                )}
                <span className="text-sm font-bold text-accent-500 whitespace-nowrap">
                  {item.hotValue}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}